export const productFaqs = [
  {
    question: "Can a pad really affect cramps and mood?",
    answer: "Yes. Pads that trap heat and moisture can increase skin irritation and local inflammation, which may worsen cramp discomfort. Eveya’s breathable, skin-safe design combined with graphene technology helps regulate temperature and dissipate heat, creating a cooler, drier environment. Graphene is known for its high thermal conductivity and anti-inflammatory properties, which support better micro-circulation."
  },
  {
    question: "I have super sensitive skin. Will these work for me?",
    answer: "Pads made with soft, breathable, and chemical-safe materials are generally better tolerated by sensitive skin. Many people with sensitive skin experience less irritation with these types of pads."
  },
  {
    question: "Why do I still leak even when I use the 'right' size pad?",
    answer: "Movement changes how fluid flows, causing it to spread sideways or backward. Pads with effective leak barriers and good fit help guide fluid into the absorbent core and reduce leakage."
  },
  {
    question: "Can a pad really stay secure all night?",
    answer: "Yes—when it’s designed for movement. Eveya’s extra-wide, multi-position wings and extended back coverage keep the pad anchored and protected from side and back leaks."
  },
  {
    question: "Why does breathability matter? It's just a pad?",
    answer: "Breathable pads allow air circulation, which reduces heat and moisture around the skin. This helps lower the risk of irritation, odor, and discomfort."
  },
  {
    question: "Do breathable pads leak more?",
    answer: "No. Breathable pads use micro-porous layers that allow air to circulate while still blocking liquid, so you get airflow without compromising leak protection."
  },
  {
    question: "Are thin pads really as absorbent as thick ones?",
    answer: "Yes. Modern super-absorbent polymers (SAPs) hold many times their weight in liquid while staying slim, providing strong absorption without bulk."
  },
  {
    question: "How long can I safely wear one pad?",
    answer: "For hygiene and skin health, it’s best to change your pad at least every 8 hours, even if it doesn’t feel full."
  },
  {
    question: "What's the big deal about dioxins?",
    answer: "Dioxins are toxic byproducts from chlorine bleaching. Choosing dioxin-free pads reduces unnecessary chemical exposure to the easily absorbent vulvar skin."
  },
  {
    question: "What actually makes Eveya different from Brand X?",
    answer: "Eveya is designed for comfort, safety, and performance. We use soft breathable layers, dioxin-free materials, multi-layer leak barriers, and extra-wide wings. Regular pads catch blood; Eveya supports your body."
  }
];

export const dischargeFaqs = [
  {
    question: "Is it normal for discharge to stain my underwear?",
    answer: "Yes. Discharge can turn yellowish or brownish on fabric when exposed to air, which is normal and not a sign of infection."
  },
  {
    question: "My discharge smells metallic/fishy during my period. Is that normal?",
    answer: "A mild metallic smell is normal due to iron in blood. A fishy odor is not normal and may indicate bacterial vaginosis—see a doctor."
  },
  {
    question: "Why is my discharge sometimes watery and sometimes thick?",
    answer: "Discharge changes with hormones. Watery discharge often appears near ovulation, while creamy or thicker discharge is common after ovulation."
  },
  {
    question: "Is douching safe?",
    answer: "No. Douching disrupts the vagina’s natural balance and increases the risk of infections. The vagina is self-cleaning."
  },
  {
    question: "When should I see a gynaecologist about discharge?",
    answer: "See a doctor if discharge changes color, develops a strong foul smell, or is accompanied by itching, burning, or pain."
  }
];

export const pantyFaqs = [
  { question: " What type of underwear should I wear during my period?", answer: "Choose mostly cotton underwear. Cotton is breathable, absorbs moisture, and helps pads stay in place, reducing leaks and irritation. Synthetic fabrics can trap heat and moisture and make pads shift. " },
  { question: "Does it matter if my underwear has spandex?", answer: "Yes. A small amount is fine, but too much stretch can make pads shift. Aim for mostly cotton underwear with up to 5% spandex. Avoid styles where polyester or spandex is the main fabric. " }
];

export const cycleFaqs = [
  { question: "Is my cycle always 28 days? ", answer: " No. A healthy cycle can range from 21–35 days. Many women naturally have shorter or longer cycles. Ovulation usually happens 12–16 days before your next period, so total length varies. If your cycle suddenly changes a lot or regularly falls outside this range, consult a doctor. " },
  { question: "Why do I crave chocolate before my period? ", answer: "Before your period, your body needs more energy, magnesium drops, and serotonin dips—so chocolate and carbs feel extra appealing. " }
];

export const bodyTypeFaqs = [
  { question: "How often should I change my pad?", answer: "Most people should change pads every 4–6 hours, and more often on heavy days. Avoid wearing a pad longer than 8 hours (except overnight pads). Changing when saturated helps prevent irritation and infections." },
  { question: "What's the difference between day pads and overnight pads?", answer: "Day pads are shorter and designed for upright movement, while overnight pads are longer, more absorbent, and provide extra backcoverage for lying down. Using the right pad for day and night improves comfort and leak protection. " }
];